import { Link as RouterLink, Outlet } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@mui/material/styles';
// components
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <>
      <HeaderStyle>
        <RouterLink to="/">
          <Box sx={{ flexGrow: 1 }}>
            <Box component={RouterLink} to="/" sx={{ display: 'inline-flex', width: 100 }}>
              <img alt="Logo" src="/static/brand/Logo-04.png" />
            </Box>
          </Box>
        </RouterLink>
      </HeaderStyle>
      <Outlet />
    </>
  );
}
